import { SalesOrderConfirmationReportLine } from './sales-order-confirmation-report-line';
import { SalesOrderDeliveryReport } from './sales-order-delivery-report';
import { SalesOrderExtraReport } from './sales-order-extra-report';
import { SalesOrderVatAnalysis } from './sales-order-vat-analysis';
import { SellingCompanyReport } from '../../../../tms-shared';

export interface SalesOrderConfirmationBalanceReport {
  id: string;
  orderNo: number;
  orderType: string;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  customerConfirmationEmailAddress: string;
  currency: string;
  currencySymbol: string;
  dateOrdered?: Date;
  enteredBy: string;
  customerAddress: string;
  deliveryAddress: string;
  paymentTerms: string;
  deliveryTerms: string;
  modeOfTransport: string;
  shipper: string;
  nettValue: number;
  taxValue: number;
  taxRate: number;
  overallValue: number;
  vatAnalysis: string;
  documentNotes: string;
  deliveryInstructions: string;
  deliveryTermNotes: string;
  shippingNotes: string;
  agentName: string;
  deliveryAddressee: string;
  printDeliveryAddress: boolean;
  sellingCompany: SellingCompanyReport;
  salesOrderLines: SalesOrderConfirmationReportLine[];
  salesOrderDeliveryItems: SalesOrderDeliveryReport[];
  salesOrderExtraItems: SalesOrderExtraReport[];
  salesOrderVatAnalysis: SalesOrderVatAnalysis[];
  orderedBy: string;
  showVatAnalysisOnDocuments: boolean;
}
